export interface CaseDeleteFormDto {
  reason: string;
}

export const createCaseDeleteFormDto = (): CaseDeleteFormDto => {
  return { reason: "" };
};
